import isEqual from "lodash/isEqual";
import {
    createContext,
    ReactNode,
    useContext,
    useEffect,
    useState,
} from "react";
import { InterpretationDataFromAPI } from "../api/types";
import _ from "lodash";

type DataType = Partial<
    Pick<
        InterpretationDataFromAPI,
        "limiting_system" | "detailed_interpretation" | "severity"
    >
>;

type InterpretationContextType = {
    data: DataType | undefined;
    initialState: DataType | undefined;
    isInterpretationDirty: boolean;
    setData: React.Dispatch<React.SetStateAction<DataType | undefined>>;
    setInitialState: React.Dispatch<React.SetStateAction<DataType | undefined>>;
};

export const InterpretationContext = createContext<
    InterpretationContextType | undefined
>(undefined);

export const useInterpretationContext = () => {
    const context = useContext(InterpretationContext);

    if (!context) {
        throw new Error(
            "useInterpretationContext must be used within a InterpretationProvider"
        );
    }

    return context;
};
const InterpretationProvider = ({ children }: { children: ReactNode }) => {
    const [initialState, setInitialState] = useState<DataType | undefined>(
        undefined
    );
    const [data, setData] = useState<DataType | undefined>(undefined);
    const [isDirty, setIsDirty] = useState(false);

    useEffect(() => {
        const changedKeys = Object.keys(data || {});
        if (!data || isEqual(_.pick(initialState, changedKeys), data)) {
            setIsDirty(false);
        } else {
            setIsDirty(true);
        }
    }, [data]);

    return (
        <InterpretationContext.Provider
            value={{
                data,
                setData,
                initialState,
                setInitialState,
                isInterpretationDirty: isDirty,
            }}
        >
            {children}
        </InterpretationContext.Provider>
    );
};

export default InterpretationProvider;
